export default __webpack_public_path__ + "static/Website Maintenance-7f612a42dde54d28e5086f6a85486c5d.jpeg";